import React, {useEffect, useState} from 'react';
import ListNav from '../../../components/tabsNav/TabsNav';
import RiskProponent from './components/riskProponent/RiskProponent'
import './SectorForms.scss';
import ITFSecurity from './components/ITFSecurity/ITFSecurity';
import {t} from 'react-switch-lang';
import ManagingCreditRisksForm from './components/managingCreditRisksForm/ManagingCreditRisksForm';
import SurForm from './components/SUR/SurForm';
import RiskLevelSum from './components/riskLevelSum/RiskLevelSum';
import PageHeader from '../../RiskComponents/pageHeader/PageHeader';
import {useLocation, useParams} from 'react-router-dom';
import SectorFinance from './components/sectorFinance/SectorFinance';
import SectorAML from './components/sectorAML/SectorAML';
import {useExternalizationContext} from '../../../contexts/ExternalizationContext';
import ExitStrategy from './components/exitStrategy/ExitStrategy';
import Spinner from 'reactstrap/lib/Spinner';
import Monitoring from "./components/monitoring/Monitoring";
import SpniftLegalComplianceForm from './components/spniftLegalComplianceForm/SpniftLegalComplianceForm';
import {
  deleteExternalization,
  getExternalizationByCycleId, rejectRequestForDeleteExternalization, requestForDeleteExternalization,
} from '../../../services/externalizations/externalizationService';
import { useHistory  } from "react-router-dom";
import Toast from '../../../components/toast/Toast';
import {useUserContext} from '../../../contexts/UserContext';
import roles from '../../../utils/roles';
import EditExternalization from './components/externalizationForm/EditExternalization';
import Swal from 'sweetalert2';
import PotentialRisks from './components/potentialRisks/PotentialRisks';

function SectorForms() {
  const [activeTab, setActiveTab] = useState('proposalForm');
  const [loadingTab, setLoadingTab] = useState(null);
  const [data, setData] = useState();
  const [externalizationId, setExternalizationId] = useState();
  const [selectedCycleId, setSelectedCycleId] = useState(null);
  const [isLastCycle, setIsLastCycle] = useState(false);
  const [isEditAllowedByStatus, setIsEditAllowedByStatus] = useState()
  const [proposalFormVerifiedInitial, setProposalFormVerifiedInitial] = useState(false)
  const [isCritical, setIsCritical] = useState(false)
  const [showEditModal, setShowEditModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const {id} = useParams();
  const user = useUserContext()
  const location = useLocation();
  const externalizationConfigData = useExternalizationContext();
  const {dataToSubmit, resultId} = location.state || {};
  const history = useHistory();
  useEffect(() => {
    if (dataToSubmit) {
      getExternalizationByCycleId(id).then((r) => {
        const status = r?.data?.status;
        setData(r?.data);
        setExternalizationId(r?.data?.id);
        setIsEditAllowedByStatus(
          status === 'ASSESSMENT_IN_PROGRESS' || status === 'REASSESSMENT_IN_PROGRESS'
        );
        setProposalFormVerifiedInitial(r?.data?.showOtherForms)
        setIsCritical(r?.data?.critical)
      }).catch(r => {
        if (r?.response?.status === 403) {
          Swal.fire({
            text: `${t('message.notAllowedExternalization')}`,
            icon: 'error',
            confirmButtonText: 'OK',
          }).then(() => window.location.href = '/externalizations')
        }
        else if(r?.response?.status === 404) {
          Swal.fire({
            text: `${t('message.externalizationNotExist')}`,
            icon: 'error',
            confirmButtonText: 'OK',
          }).then(() => window.location.href = '/externalizations')
        }
      })
    } else {
      getExternalizationByCycleId(id).then((r) => {
        const status = r?.data?.status;
        setData(r?.data);
        setExternalizationId(r?.data?.id);
        setIsEditAllowedByStatus(
          status === 'ASSESSMENT_IN_PROGRESS' || status === 'REASSESSMENT_IN_PROGRESS'
        );
        setProposalFormVerifiedInitial(r?.data?.showOtherForms)
        setIsCritical(r?.data?.critical)
      }).catch(r => {
        if (r?.response?.status === 403) {
          Swal.fire({
            text: `${t('message.notAllowedExternalization')}`,
            icon: 'error',
            confirmButtonText: 'OK',
          }).then(() => window.location.href = '/externalizations')
        }
        else if(r?.response?.status === 404) {
          Swal.fire({
            text: `${t('message.externalizationNotExist')}`,
            icon: 'error',
            confirmButtonText: 'OK',
          }).then(() => window.location.href = '/externalizations')
        }
      })
    }
  }, [id, dataToSubmit, resultId]);

  const handleOpenEditExternalization = () => {
    setEditData(data);
    setShowEditModal(true);
  };
  useEffect(() => {
    const queryString = require('query-string');
    const parsed = queryString.parse(location.search);
    if (parsed.tab) {
      setActiveTab(parsed.tab);
    }
  }, [location.search]);

  const userRiskSector = useUserContext().authorities.some((r) =>
    r.includes(roles.role_risk_sector)
  );
  const requestForDeleteExternalizationBtn = ((user?.id === data?.proposalFormUserInChargeId  || user?.id === data?.proposalFormUserInChargeDeputyId) && !userRiskSector)
  const editExternalizationBtn = userRiskSector || (user?.id === data?.proposalFormUserInChargeId)  || (user?.id === data?.proposalFormUserInChargeDeputyId)
  const onRequestForDeleteExternalization = async () => {
    try {
      const response = await requestForDeleteExternalization(id);
      if (response.status === 200) {
        await Toast.fire({
          title: t('title.requestForDeleteExternalization'), icon: 'success',
        });
      }
    } catch (err) {
    }
  };
  const handleAcceptDeleteExternalization = async () => {
    try {
      const response = await deleteExternalization(id);
      if (response.status === 204) {
        await Toast.fire({
          title: t('message.deleteSuccess3', {entity: t('externalization.externalization')}), icon: 'success'
        });
      }
      await history.push('/externalizations');
    } catch (err) {
    }
  };
  const handleRejectDeleteExternalization = async () => {
    try {
      const response = await rejectRequestForDeleteExternalization(id);
      if (response.status === 200) {
        await Toast.fire({
          title: t('title.rejectRequestForDelete'), icon: 'success',
        });
      }
      await window.location.reload();
    } catch (err) {
    }
  };
  return (<>
    { <>
      <div className={'fixedFieldsWrapper'}>
        <PageHeader
          id={'3'}
          correctTab={activeTab}
          url={'/externalizations'}
          deleteAllow={true}
          externalizationTitle={dataToSubmit ? dataToSubmit?.serviceProvider?.name : data?.serviceProviderName}
          externalizationSubject={dataToSubmit ? dataToSubmit?.contractSubject : data?.contractSubject}
          externalizationTin={dataToSubmit ? dataToSubmit?.serviceProvider?.tin : data?.serviceProviderTin}
          externalizationCycle={true}
          externalizationId={externalizationId}
          onCycleChange={(cycleId, allCycles) => {
            setSelectedCycleId(cycleId);
            const lastCycleId = allCycles?.[0]?.value;
            setIsLastCycle(cycleId === lastCycleId);
          }}
          externalizationStatus={dataToSubmit ? dataToSubmit?.status : data?.status}
          requestForDeleteExternalizationBtn={requestForDeleteExternalizationBtn}
          onRequestForDeleteExternalization={(e) => onRequestForDeleteExternalization(e)}
          editExternalizationBtn={editExternalizationBtn}
          onEditExternalization={handleOpenEditExternalization}
          acceptRejectDeleteExternalization={userRiskSector && data?.deletionRequested}
          onAcceptRequestForDeleteExternalization={(e) => handleAcceptDeleteExternalization(e)}
          onRejectForDeleteExternalization={(e) => handleRejectDeleteExternalization(e)}
        />
      </div>
      {showEditModal && (
        <EditExternalization
          data={editData}
          id="externalization"
          onClose={() => setShowEditModal(false)}
        />
      )}
        <ListNav
        items={[{
          name: t('externalization.proponent'),
          target: externalizationConfigData?.find((formData) => formData.position === 1)?.formKey,
        }, proposalFormVerifiedInitial  && isCritical && {
          name: t('externalization.exitStrategy'),
          target: externalizationConfigData?.find((formData) => formData.position === 2)?.formKey,
        }, proposalFormVerifiedInitial && {
          name: t('externalization.spniftSector'),
          target: externalizationConfigData?.find((formData) => formData.position === 3)?.formKey,
        }, proposalFormVerifiedInitial && {
          name: t('externalization.legalSector'),
          target: externalizationConfigData?.find((formData) => formData.position === 4)?.formKey,
        }, proposalFormVerifiedInitial && {
          name: t('externalization.ITFSecurityForm.ITFSecurity'),
          target: externalizationConfigData?.find((formData) => formData.position === 5)?.formKey,
        }, proposalFormVerifiedInitial && {
          name: t('externalization.financeSector'),
          target: externalizationConfigData?.find((formData) => formData.position === 6)?.formKey,
        }, proposalFormVerifiedInitial && {
          name: t('externalization.complianceMonitoringSector'),
          target: externalizationConfigData?.find((formData) => formData.position === 7)?.formKey,
        }, proposalFormVerifiedInitial && {
          name: t('externalization.assetManagementSector'),
          target: externalizationConfigData?.find((formData) => formData.position === 8)?.formKey,
        }, proposalFormVerifiedInitial && {
          name: t('externalization.creditRiskManagement'),
          target: externalizationConfigData?.find((formData) => formData.position === 9)?.formKey,
        }, proposalFormVerifiedInitial && {
          name: t('externalization.SUR'),
          target: externalizationConfigData?.find((formData) => formData.position === 10)?.formKey,
        },
          proposalFormVerifiedInitial && {
            name: t('externalization.monitoring'), target: 'monitoring'
          },
          proposalFormVerifiedInitial && {
            name: t('externalization.riskProfile'), target: 'riskProfile',
          },
          proposalFormVerifiedInitial && {
          name: t('externalization.overallRiskLevel'), target: 'riskLevel',
        }]}
        textProperty='name'
        itemValue='target'
        selectedItem={activeTab}
        classes='tabs-nav ml-0'
        onItemSelect={async (tab) => {
          setLoadingTab(tab);
          setActiveTab(tab);
          history.replace(`?tab=${tab}`);
          setLoadingTab(null);
        }}
      />
    </>}
    {loadingTab === activeTab ? (
      <div className="text-center mt-4 mb-4">
        <Spinner animation="border" role="status" />
      </div>
    ) : ( <div className={'formWrapper'}>
      {activeTab === 'proposalForm' &&
        <RiskProponent externalizationId={resultId} externalizationData={dataToSubmit}
                       key={`proposalForm-${selectedCycleId}`} isLastCycle={isLastCycle} isEditAllowedByStatus={isEditAllowedByStatus} cycleId={selectedCycleId}
                       externalizationFormConfigData={externalizationConfigData?.find((formData) => formData?.formKey === 'proposalForm')}
                     />}
      {activeTab === 'exitStrategyForm' &&
        <ExitStrategy key={`exitStrategyForm-${selectedCycleId}`} isLastCycle={isLastCycle} isEditAllowedByStatus={isEditAllowedByStatus} cycleId={selectedCycleId}
          externalizationFormConfigData={externalizationConfigData?.find(
        (formData) => formData?.formKey === 'exitStrategyForm')}
        />}
      {activeTab === 'spniftForm' &&
        <SpniftLegalComplianceForm key={`spniftForm-${selectedCycleId}`} isLastCycle={isLastCycle} isEditAllowedByStatus={isEditAllowedByStatus} cycleId={selectedCycleId} fieldName={'spniftClientAcceptability'}
                                           name={activeTab}
                                           externalizationFormConfigData={externalizationConfigData?.find((formData) => formData?.formKey === 'spniftForm')}
      />}
      {activeTab === 'legalForm' &&
        <SpniftLegalComplianceForm key={`legalForm-${selectedCycleId}`} isLastCycle={isLastCycle} isEditAllowedByStatus={isEditAllowedByStatus} cycleId={selectedCycleId} fieldName={'legalClientAcceptability'} name={activeTab}
                                          externalizationFormConfigData={externalizationConfigData?.find((formData) => formData?.formKey === 'legalForm')}
      />}
      {activeTab === 'itfSecurityForm' &&
        <ITFSecurity externalizationId={id} key={`itfSecurityForm-${selectedCycleId}`} isLastCycle={isLastCycle} isEditAllowedByStatus={isEditAllowedByStatus} cycleId={selectedCycleId}
                     externalizationFormConfigData={externalizationConfigData?.find((formData) => formData?.formKey === 'itfSecurityForm')}
      />}
      {activeTab === 'financeForm' &&
        <SectorFinance key={`financeForm-${selectedCycleId}`} isLastCycle={isLastCycle} isEditAllowedByStatus={isEditAllowedByStatus} cycleId={selectedCycleId} externalizationFormConfigData={externalizationConfigData?.find((formData) => formData?.formKey === 'financeForm')}
      />}
      {activeTab === 'controllingForm' &&
        <SectorAML key={`controllingForm-${selectedCycleId}`} isLastCycle={isLastCycle} isEditAllowedByStatus={isEditAllowedByStatus} cycleId={selectedCycleId} externalizationFormConfigData={externalizationConfigData?.find((formData) => formData?.formKey === 'controllingForm')}
      />}
      {activeTab === 'complianceForm' &&
        <SpniftLegalComplianceForm key={`complianceForm-${selectedCycleId}`} isLastCycle={isLastCycle} isEditAllowedByStatus={isEditAllowedByStatus} cycleId={selectedCycleId} fieldName={'complianceRiskLevel'}
              name={activeTab}
              externalizationFormConfigData={externalizationConfigData?.find((formData) => formData?.formKey === 'complianceForm')}
        />}
      {activeTab === 'creditRiskManagementForm' &&
        <ManagingCreditRisksForm key={`creditRiskManagementForm-${selectedCycleId}`} isLastCycle={isLastCycle} isEditAllowedByStatus={isEditAllowedByStatus} cycleId={selectedCycleId}
          externalizationFormConfigData={externalizationConfigData?.find((formData) => formData?.formKey === 'creditRiskManagementForm')}
        />}
      {activeTab === 'bankRiskProfileForm' &&
        <SurForm key={`bankRiskProfileForm-${selectedCycleId}`} isLastCycle={isLastCycle} isEditAllowedByStatus={isEditAllowedByStatus} cycleId={selectedCycleId} externalizationFormConfigData={externalizationConfigData?.find((formData) => formData?.formKey === 'bankRiskProfileForm')}
      />}
      {activeTab === 'monitoring' && <Monitoring isLastCycle={isLastCycle} cycleId={selectedCycleId}/>}
        {activeTab === 'riskProfile' && <PotentialRisks cycleId={selectedCycleId}/>}
      {activeTab === 'riskLevel' && <RiskLevelSum cycleId={selectedCycleId}/>}
    </div>
    )}
  </>);
}

export default SectorForms;